import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { showErrorNotification, updateQuery } from '../actions/App';
import * as statisticsActions from '../actions/Statistics';
import * as statisticsApi from '../api/Statistics';
import { GET_STATISTICS, GET_STATISTICS_CATEGORIES } from '../constants/ActionTypes';
import { STATISTICS_QUERY_PARAMS } from '../constants/Values';

function* getStatistics({ payload }) {
  try {
    const { data } = yield call(statisticsApi.getStatistics, {
      ...payload.filters,
      pagination: payload.pagination,
    });
    yield put(updateQuery(payload.pagination, STATISTICS_QUERY_PARAMS, payload.filters));
    yield put(statisticsActions.getStatisticsSuccess(data.entities, data.pageCount));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* getStatisticsCategories() {
  try {
    const { data } = yield call(statisticsApi.getCategories);
    yield put(statisticsActions.getStatisticsCategoriesSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

export function* getStatisticsSaga() {
  yield takeLatest(GET_STATISTICS, getStatistics);
}

export function* getStatisticsCategoriesSaga() {
  yield takeLatest(GET_STATISTICS_CATEGORIES, getStatisticsCategories);
}

export default function* rootSaga() {
  yield all([fork(getStatisticsSaga), fork(getStatisticsCategoriesSaga)]);
}
